document.addEventListener('DOMContentLoaded', function () {
  if (sessionStorage.getItem('pricesIncludeVat') == null) {
    sessionStorage.setItem('pricesIncludeVat', 'false');
  }

  const includeVAT = sessionStorage.getItem('pricesIncludeVat') === 'true';
  calculatePrices(includeVAT);
  updateTextToVat(includeVAT);

  const toggles = document.querySelectorAll('.vat-switcher-toggle');
  toggles.forEach((toggle) => {
    updateToggleVisuals(toggle, includeVAT);
    toggle.addEventListener('click', () => toggleTaxPrices(toggle));
  });
});

function toggleTaxPrices(toggle) {
  const pricesIncludeVat = sessionStorage.getItem('pricesIncludeVat');

  if (pricesIncludeVat == null) {
    sessionStorage.setItem('pricesIncludeVat', 'false');
  } else {
    if (pricesIncludeVat === 'false') {
      sessionStorage.setItem('pricesIncludeVat', 'true');
      document.querySelectorAll('.vat-switcher-title').forEach((title) => {
        title.innerHTML = `Incl. BTW`;
      });
      updateToggleVisuals(toggle, true);
      calculatePrices(true); // Switch to including VAT prices
      updateTextToVat(true);
    } else {
      sessionStorage.setItem('pricesIncludeVat', 'false');
      document.querySelectorAll('.vat-switcher-title').forEach((title) => {
        title.innerHTML = `Excl. BTW`;
      });
      updateToggleVisuals(toggle, false);
      calculatePrices(false); // Switch to excluding VAT prices
      updateTextToVat(false);
    }
  }
}

function calculatePrices(includeVAT) {
  const prices = document.querySelectorAll('[data-excl-price]'); // Now using only data-excl-price

  prices.forEach((priceElement) => {
    const exclPrice = parseFloat(priceElement.dataset.exclPrice); // Retrieve the excluding VAT price from the data attribute
    const vatPercentage = 21; // Assume VAT is 21%

    if (isNaN(exclPrice)) {
      console.error('Invalid price found on element:', priceElement);
      return;
    }

    const inclPrice = exclPrice * (1 + vatPercentage / 100); // Calculate price including VAT

    priceElement.innerHTML = includeVAT
      ? `${(inclPrice / 100).toFixed(2).replace('.', ',')}` // Show price including VAT
      : `${(exclPrice / 100).toFixed(2).replace('.', ',')}`; // Show price excluding VAT
  });
}

function updateTextToVat(includeVAT) {
  const texts = document.querySelectorAll('*:not(script):not(style)');
  texts.forEach((element) => {
    element.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.textContent;
        if (includeVAT) {
          text = text
            .replace(/excl\. BTW/g, 'incl. BTW')
            .replace(/excl\. btw/g, 'incl. btw')
            .replace(/Excl\. BTW/g, 'Incl. BTW');
          node.textContent = text;
        } else {
          text = text
            .replace(/incl\. BTW/g, 'excl. BTW')
            .replace(/incl\. btw/g, 'excl. btw')
            .replace(/Incl\. BTW/g, 'Excl. BTW');
          node.textContent = text;
        }
      }
    });
  });
}

function updateToggleVisuals(toggle, includeVAT) {
  if (!toggle) return;

  if (includeVAT) {
    document.querySelectorAll('.vat-switcher-title').forEach((title) => {
      title.innerHTML = `Incl. BTW`;
    });
  } else {
    document.querySelectorAll('.vat-switcher-title').forEach((title) => {
      title.innerHTML = `Excl. BTW`;
    });
  }

  const togglers = toggle.querySelectorAll('.toggler');
  if (togglers) {
    togglers.forEach((toggle) => {
      toggle.classList.toggle('left-22', includeVAT);
      toggle.classList.toggle('left-2', !includeVAT);
    });
  }
}
